import React from "react";
import { Box, Radio } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicRadioColor = () => {
  return (
    <Box mb={2}>
      <PreviewAndEditor
        title={
          "Basic radio colors - default, primary, secondary, error, warning, info, success"
        }
        language={"js"}
        value={"        <Radio checked={true} size=\"large\" />\n" +
            "        <Radio checked={true} color=\"primary\" size=\"large\" />\n" +
            "        <Radio checked={true} color=\"secondary\" size=\"large\" />\n" +
            "        <Radio checked={true} color=\"error\" size=\"large\" />\n" +
            "        <Radio checked={true} color=\"warning\" size=\"large\" />\n" +
            "        <Radio checked={true} color=\"info\" size=\"large\" />\n" +
            "        <Radio checked={true} color=\"success\" size=\"large\" />"}
      >
        <Radio checked={true} size="large" />
        <Radio checked={true} color="primary" size="large" />
        <Radio checked={true} color="secondary" size="large" />
        <Radio checked={true} color="error" size="large" />
        <Radio checked={true} color="warning" size="large" />
        <Radio checked={true} color="info" size="large" />
        <Radio checked={true} color="success" size="large" />
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicRadioColor;
